import { gql } from '@apollo/client';
// src/components/login-query.tsx
// This file contains the GraphQL query for logging in a collection point user.
export const COLLECTIONPOINT_LOGIN = gql`
  query collectionpointLogin($search: String!) {
    collectionpointLogin(search: $search) {
      jwt
      userMustChangePassword
      expirationDate
      collectionpointId
    }
  }
`;
